import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const ExperimentFlask = ({
  height = 16,
  width = 16,
  color = colors.grey60,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M8.04449 3.5625H15.9195"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.7945 9.1875V3.5625H9.1695V9.1875L4.11676 16.9612C3.89616 17.3006 3.7712 17.6932 3.75503 18.0976C3.73886 18.5021 3.83209 18.9034 4.0249 19.2593C4.2177 19.6152 4.50293 19.9124 4.85054 20.1198C5.19814 20.3272 5.59525 20.4369 6.00001 20.4375H17.961C18.366 20.4375 18.7635 20.3281 19.1115 20.121C19.4596 19.9138 19.7452 19.6166 19.9384 19.2606C20.1316 18.9046 20.225 18.5031 20.209 18.0984C20.193 17.6937 20.068 17.3008 19.8473 16.9612L14.7945 9.1875Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.97577 12.5625H16.9883"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
